const API = process.env.REACT_APP_BACKEND_URL;

function pick(text, key) {
  const m = text.match(new RegExp(`"${key}"\\s*:\\s*"((?:[^"\\\\]|\\\\.)*)("?)`));
  if (!m) return null;
  return m[1].replace(/\\n/g, " ").replace(/\\"/g, '"');
}
function pickList(text, key) {
  const i = text.indexOf(`"${key}"`);
  if (i === -1) return [];
  const open = text.indexOf("[", i);
  if (open === -1) return [];
  const chunk = text.slice(open + 1).split("]")[0];
  return [...chunk.matchAll(/"((?:[^"\\]|\\.)*)("?)/g)].map((x) => x[1]).filter(Boolean);
}

/** Lenient reader of a partial JSON stage result so the UI can render it while it streams. */
export function partialStage(text) {
  return { title: pick(text, "title"), summary: pick(text, "summary"), points: pickList(text, "points"), momentum: pick(text, "momentum") };
}

/** POST the stage answer and stream SSE deltas. onDelta(fullText), resolves with the final payload. */
export async function streamStage(projectId, body, onDelta) {
  const res = await fetch(`${API}/api/projects/${projectId}/stage/stream`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = res.statusText;
    try { detail = (await res.json()).detail || detail; } catch (e) {}
    const err = new Error(detail); err.status = res.status; throw err;
  }
  const reader = res.body.getReader(), dec = new TextDecoder();
  let buf = "", text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n"); buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.type === "delta") { text += ev.text; onDelta(text); }
      else if (ev.type === "done") return ev;
      else if (ev.type === "error") { const err = new Error(ev.detail); err.status = 500; throw err; }
    }
  }
  throw new Error("Stream ended unexpectedly");
}
